import moment from "moment";
import { CurrencyFormat } from "../../../../../components/helpers";

export const convertDetailCommission = (data) => {
  let converted = [];

  if (!data) return [];

  data.forEach((item, index) => {
    converted.push({
      key: index + 1,
      id: item.id,
      dateTime: moment(item.created_at).format("DD/MM/YYYY HH:mm") || "-",
      customerName: item.customer_commission.customer_name || "-",
      sbg: item.customer_commission.sbg_code || "-",
      loanAmount:
        `Rp ${CurrencyFormat(item.customer_commission.loan_amount)}` || "0",

      totalInterest:
        `Rp ${CurrencyFormat( item.customer_commission.capital_loan > 0
            ? item.customer_commission.capital_loan
            : item.customer_commission.loan_amount)}` || "0",

      commission:
        `${
          item.customer_commission.capital_loan > 0
            ? item.customer_commission.percent_capital_loan
            : item.customer_commission.percent_loan_amount
        } %` || "-",
      commissionValue:
        `Rp ${CurrencyFormat(item.customer_commission.amount)}` || "0",
    });
  });
  return converted;
};
